<template>
  <b-card>
    <div slot="header">
      <strong>Change Password</strong>
    </div>
    <b-form-fieldset label="Your Password">
      <b-form-input v-model="password" type="password" placeholder="Enter Password.."></b-form-input>
    </b-form-fieldset>
    <b-form-fieldset label="New Password">
      <b-form-input v-model="newpass" type="password" placeholder="Enter New Password.."></b-form-input>
    </b-form-fieldset>
    <b-form-fieldset
      label="Re-Type New Password"
      description="Please enter your password.">
      <b-form-input v-model="retypepass" type="password" placeholder="Re-Type New Password.."></b-form-input>
    </b-form-fieldset>
    <div slot="footer">
      <b-button @click="change" type="submit" size="sm" variant="primary"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
    </div>
  </b-card>
</template>
<script>
import swal from 'sweetalert'
export default {
  name: 'changepass',
  data () {
    return {
      password: '',
      newpass: '',
      retypepass: ''
    }
  },
  methods: {
    change () {
      this.$Progress.start()
      var data = {
        user: this.$store.getters['auth/user']['username'],
        password: this.password,
        newpass: this.newpass,
        retypepass: this.retypepass
      }
      if (this.newpass === this.retypepass) {
        this.$http.post('changepw', data)
          .then(response => {
            swal(response.data.status, response.data.message, response.data.status)
            this.$router.push('/')
            this.$Progress.finish()
          })
      } else {
        swal('', 'New Password not match Re-Type Password', 'error')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/account/ChangePass.vue?1f1ee0c8